
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import labelApi from '@/services/api.labelSetup.service';
import vSelect3 from "vselect3";
import { Label, LabelPagedResonse, LabelTypeQueryParams } from '@/store/labels/types';
import PaginatedSearch, { PaginatedSearchRequest } from '@/mixins/PaginatedSearch';
import { paginatedSearchExtendedMixins } from '@/mixins/paginatedSearchExtendedMixins';

const { fetchAllResults } = paginatedSearchExtendedMixins.methods;

@Component({
    components: {
        "v-select-3": vSelect3
    }
})
export default class LabelDropdown extends Mixins(PaginatedSearch) {

    @Prop({ type: Number, required: false }) ObjectId: number | null;
    @Prop({ type: Number, required: true }) LabelTypeId: number;
    @Prop({ type: Boolean, default: true }) Multiple: boolean;
    @Prop({ type: String, default: "Select Labels" }) DropdownTitle: string;
    @Prop({ type: String, default: "Select Labels" }) DropdownPlaceholder: string;
    @Prop({ type: Boolean }) ShowTitle: boolean;

    private selectedLabels: Label[] = [];
    private labelOptions: Label[] = [];

    private paginatedSearchQueryParams: LabelTypeQueryParams = {
		page: 1,
        pageSize: 5,
        labelTypeId: null
    };

    @Watch("LabelTypeId", { immediate: true })
    private async onLabelTypeIdChange(): Promise<void> {
        this.paginatedSearchQueryParams.labelTypeId = this.LabelTypeId;
        await this.loadAllLabels();
    }

    @Watch("ObjectId", { immediate: true })
    private async onObjectIdChange(newValue: number | null): Promise<void> {
        await this.loadAllLabels();
        if (newValue === null) {
            this.selectedLabels = [];
            this.emitLabelsLoaded();
            return;
        }
        await this.loadLabelsForObject();
    }

    private async loadAllLabels(): Promise<void> {
        try {
            const request: PaginatedSearchRequest = {
				params: { ...this.paginatedSearchQueryParams },
				cancelToken: undefined
			};

            const { data } = await fetchAllResults<LabelPagedResonse>(labelApi, labelApi.GetLabelsByLabelType, request);
            this.labelOptions = data;

        } catch (error) {
            console.error("Error loading labels:", error);
        }
    }

    private async loadLabelsForObject(): Promise<void> {
        try {
            this.selectedLabels = await labelApi.GetLabelsForObject(this.ObjectId, this.LabelTypeId);
            this.emitLabelsLoaded()
        } catch (error) {
            console.error("Error loading selected labels:", error);
        }
    }

    @Emit("labels-selected")
    private onSelectionChange(values: number[]): number[] {
        return values;
    }

    @Emit("labels-loaded")
    private emitLabelsLoaded(): number[] {
        return this.selectedLabels.map(label => label.labelId);
    }
}
